/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { ClaimImageDTO } from './ClaimImageDTO';
import type { ClaimShippingDTO } from './ClaimShippingDTO';
export type ClaimCentralProcessDTO = {
    shopId?: string;
    ownerStatus?: ClaimCentralProcessDTO.ownerStatus;
    receiverStatus?: ClaimCentralProcessDTO.receiverStatus;
    createdAt?: string;
    images?: Array<ClaimImageDTO>;
    claimShipping?: ClaimShippingDTO;
    note?: string;
};
export namespace ClaimCentralProcessDTO {
    export enum ownerStatus {
        NONE = 'NONE',
        PREPARE = 'PREPARE',
        SENT = 'SENT',
        CHECK_PRODUCT = 'CHECK_PRODUCT',
        IN_PROGRESS = 'IN_PROGRESS',
        REPAIR_FINISH = 'REPAIR_FINISH',
        WAIT_RECEIVE = 'WAIT_RECEIVE',
        COMPLETE = 'COMPLETE',
        CANCEL = 'CANCEL',
        WAIT_CANCEL = 'WAIT_CANCEL',
        COMPLETE_CANCEL = 'COMPLETE_CANCEL',
    }
    export enum receiverStatus {
        NONE = 'NONE',
        WAIT_PRODUCT = 'WAIT_PRODUCT',
        CHECK_PRODUCT = 'CHECK_PRODUCT',
        IN_PROGRESS = 'IN_PROGRESS',
        REPAIR_FINISH = 'REPAIR_FINISH',
        SENT_PRODUCT = 'SENT_PRODUCT',
        COMPLETE = 'COMPLETE',
        CANCEL = 'CANCEL',
        WAIT_CANCEL = 'WAIT_CANCEL',
        COMPLETE_CANCEL = 'COMPLETE_CANCEL',
    }
}

